
import React from 'react';
import CheckoutSection from '@/components/payment/CheckoutSection';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface CheckoutContentProps {
  selectedProductIds: string[];
  selectedProducts: any[];
  primaryProduct: any;
  externalUserId?: string;
  externalProductId?: string;
}

const CheckoutContent: React.FC<CheckoutContentProps> = ({
  selectedProductIds,
  selectedProducts,
  primaryProduct,
  externalUserId,
  externalProductId
}) => {

  // Check for subscriptions in selected products
  const hasSubscriptions = selectedProducts.some(product => 
    product.is_subscription === true || 
    product.type === 'subscription' || 
    product.billing_period === 'month' ||
    product.billing_period === 'year'
  );

  // Make sure we actually have a primary product
  if (!primaryProduct) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          No primary product available for checkout. Please select at least one product.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="mt-6">
      <CheckoutSection 
        selectedProductIds={selectedProductIds}
        selectedProducts={selectedProducts}
        primaryProduct={primaryProduct}
        externalUserId={externalUserId}
        externalProductId={externalProductId}
      />
    </div>
  );
};

export default CheckoutContent;